import { LuChevronDown, LuEye } from 'react-icons/lu'
import {
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	TableContainer,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	Button,
	Flex,
	Icon,
	AlertDialog,
	AlertDialogOverlay,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogBody,
	AlertDialogFooter,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalCloseButton,
	ModalBody,
	ModalFooter,
	Box
} from '@chakra-ui/react'
import React, { useRef, useState } from 'react'

const TableList = ({ list, getPage }) => {
	const [confirmIndex, setConfirmIndex] = useState(null);
	const [viewUrl, setViewUrl] = useState(null);
	const cancelRef = useRef();

	const maskParams = (url) => {
		try {
			const parsedUrl = new URL(url);
			const params = [...parsedUrl.searchParams.keys()]
				.map(key => `${key}=***`)
				.join('&');

			return `${parsedUrl.origin}${parsedUrl.pathname}${params ? `?${params}` : ''}`;
		} catch (e) {
			return 'Invalid URL';
		}
	};

	const handleConfirmView = (url) => {
		setViewUrl(url);
		setConfirmIndex(null);
	};

	const handleCloseModal = () => {
		setViewUrl(null);
	};

	return (
		<TableContainer width="100%">
			<Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
				<Thead>
					<Tr>
						<Th>Account Name</Th>
						<Th>Method</Th>
						<Th>End Point</Th>
						<Th>Status</Th>
						<Th></Th>
					</Tr>
				</Thead>

				<Tbody fontSize="14px">
					{list?.map((rs, index) => {
						const configData = JSON.parse(rs.api_config);
						const fullUrl = configData.url;

						return (
							<Tr key={index}>
								<Td>{rs.account_name}</Td>
								<Td>{configData.method}</Td>
								<Td
									sx={{
										whiteSpace: 'normal',
										wordBreak: 'break-word',
										minWidth: '400px',
										maxWidth: '40%',
										p: 4,
										verticalAlign: 'top',
									}}
								>
									<Flex align="center" >
										<Box>{maskParams(fullUrl)} <Icon
											as={LuEye}
											size="lg"
											ml={4}
											colorScheme="blue"
											style={{ cursor: 'pointer' }}
											fontSize="lg"
											onClick={() => setConfirmIndex(index)}
										/></Box>
										

									</Flex>

									{/* Confirmation Dialog */}
									<AlertDialog
										isOpen={confirmIndex === index}
										leastDestructiveRef={cancelRef}
										onClose={() => setConfirmIndex(null)}
									>
										<AlertDialogOverlay>
											<AlertDialogContent>
												<AlertDialogHeader fontSize="lg" fontWeight="bold">
													View Full URL
												</AlertDialogHeader>
												<AlertDialogBody>
													Are you sure you want to view the full endpoint with parameters?
												</AlertDialogBody>
												<AlertDialogFooter>
													<Button ref={cancelRef} onClick={() => setConfirmIndex(null)}>
														Cancel
													</Button>
													<Button colorScheme="blue" onClick={() => handleConfirmView(fullUrl)} ml={3}>
														View
													</Button>
												</AlertDialogFooter>
											</AlertDialogContent>
										</AlertDialogOverlay>
									</AlertDialog>
								</Td>

								<Td>{rs.status_id === 1 ? "Active" : "InActive"}</Td>

								<Td style={{ color: "#0000EE" }}>
									<Menu>
										<MenuButton fontSize="14px">
											Action <Icon as={LuChevronDown} />
										</MenuButton>
										<MenuList style={{ minWidth: "20px", border: "1px solid #CCCCCC" }}>
											<MenuItem h="16px" fontSize="12px" onClick={() => getPage('editVoice', '4', rs)}>
												Edit
											</MenuItem>
										</MenuList>
									</Menu>
								</Td>
							</Tr>
						);
					})}
				</Tbody>
			</Table>

			{/* Modal to Show Full URL */}
			<Modal isOpen={viewUrl !== null} onClose={handleCloseModal} size="lg">
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Endpoint</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Box bg="gray.100" p={4} rounded="md" fontFamily="monospace">
							{viewUrl}
						</Box>
					</ModalBody>
					<ModalFooter>
						<Button onClick={handleCloseModal}>Close</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</TableContainer>
	);
};

export default TableList;
